<!--<app-navigation-bar *ngIf="usuario != undefined"></app-navigation-bar>-->
<!--<div class="corpo">-->
<!--    <app-menu *ngIf="usuario != undefined"-->
<!--    [role]="usuario.roles[0].nome"-->
<!--    [imagemUsuario]="usuario.imagem"-->
<!--    ></app-menu>-->
<!--    <router-outlet></router-outlet>-->
<!--</div>-->
<!--<app-loader-view></app-loader-view>-->
<body>
<aside *ngIf="showMenu | async" class="sidebar">
  <div class="logo">
    <div class="logo-icon">
      <img src="assets/images/icon-03.svg" width="22px">
    </div>
    <div class="logo-text">Jota Vendas</div>
  </div>
    <ul class="nav-menu">
      <li class="nav-item">
        <a [href]="'/'+role" class="nav-link" [ngClass]="{ 'active': isActive('') }">
          <div class="nav-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M12 20V10"></path>
              <path d="M18 20V4"></path>
              <path d="M6 20v-6"></path>
            </svg>
          </div>
          <span class="nav-text">Indicadores</span>
        </a>
      </li>
      <li class="nav-item">
        <a routerLink="/admin/usuarios" *ngIf="role === 'admin'" class="nav-link" [ngClass]="{ 'active': isActive('usuarios') }">
          <div class="nav-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
              <circle cx="12" cy="7" r="4"></circle>
            </svg>
          </div>
          <span class="nav-text">Usuarios</span>
        </a>
      </li>
      <li class="nav-item">
        <a [href]="'/'+role+'/empresas'" *ngIf="role === 'admin'" class="nav-link" [ngClass]="{ 'active': isActive('empresas') }">
          <div class="nav-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
              <circle cx="12" cy="10" r="3"></circle>
            </svg>
          </div>
          <span class="nav-text">Empresas</span>
        </a>
      </li>
      <li class="nav-item">
        <a [href]="'/'+role+'/agenda'" *ngIf="role === 'master'" class="nav-link" [ngClass]="{ 'active': isActive('agenda') }">
          <div class="nav-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
              <line x1="16" y1="2" x2="16" y2="6"></line>
              <line x1="8" y1="2" x2="8" y2="6"></line>
              <line x1="3" y1="10" x2="21" y2="10"></line>
            </svg>
          </div>
          <span class="nav-text">Agenda</span>
        </a>
      </li>
      <li class="nav-item">
        <a [href]="'/'+role+'/fornecedores'" *ngIf="role === 'master'" class="nav-link" [ngClass]="{ 'active': isActive('fornecedores') }">
          <div class="nav-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
              <circle cx="12" cy="10" r="3"></circle>
            </svg>
          </div>
          <span class="nav-text">Fornecedores</span>
        </a>
      </li>
      <li class="nav-item">
        <a routerLink="/master/produtos" *ngIf="role === 'master'" class="nav-link" [ngClass]="{ 'active': isActive('produtos') }">
          <div class="nav-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M20 9v9a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V9"></path>
              <path d="M9 3h6a2 2 0 0 1 2 2v4H7V5a2 2 0 0 1 2-2z"></path>
              <line x1="12" y1="12" x2="12" y2="17"></line>
              <line x1="8" y1="12" x2="16" y2="12"></line>
            </svg>
          </div>
          <span class="nav-text">Estoque</span>
        </a>
      </li>
      <li class="nav-item">
        <a [href]="'/'+role+'/vendas'" *ngIf="role !== 'admin'" class="nav-link" [ngClass]="{ 'active': isActive('vendas') }">
          <div class="nav-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <line x1="12" y1="1" x2="12" y2="23"></line>
              <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>
            </svg>
          </div>
          <span class="nav-text">Vendas</span>
        </a>
      </li>
      <li class="nav-item">
        <a [href]="'/'+role+'/caixa'" *ngIf="role === 'master'" class="nav-link" [ngClass]="{ 'active': isActive('caixa') }">
          <div class="nav-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <rect x="2" y="4" width="20" height="16" rx="2"></rect>
              <path d="M12 8v8"></path>
              <path d="M16 12H8"></path>
            </svg>
          </div>
          <span class="nav-text">Caixa</span>
        </a>
      </li>
      <li class="nav-item">
        <a [href]="'/'+role+'/caixa'" *ngIf="role === 'user'" class="nav-link" [ngClass]="{ 'active': isActive('caixa') }">
          <div class="nav-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <rect x="2" y="4" width="20" height="16" rx="2"></rect>
              <path d="M12 8v8"></path>
              <path d="M16 12H8"></path>
            </svg>
          </div>
          <span class="nav-text">Caixa</span>
        </a>
      </li>
      <li class="nav-item">
        <a routerLink="/master/funcionarios" *ngIf="role === 'master'" class="nav-link" [ngClass]="{ 'active': isActive('funcionarios') }">
          <div class="nav-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
              <circle cx="9" cy="7" r="4"></circle>
              <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
              <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
            </svg>
          </div>
          <span class="nav-text">Funcionários</span>
        </a>
      </li>
      <li class="nav-item">
        <a routerLink="/master/clientes" *ngIf="role !== 'admin'" class="nav-link" [ngClass]="{ 'active': isActive('clientes') }">
          <div class="nav-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
              <circle cx="12" cy="7" r="4"></circle>
            </svg>
          </div>
          <span class="nav-text">Clientes</span>
        </a>
      </li>
      <li class="nav-item">
        <a [routerLink]="'/'+role+'/configuracao'" class="nav-link" [ngClass]="{ 'active': isActive('configuracao') }">
          <div class="nav-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="3"></circle>
              <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path>
            </svg>
          </div>
          <span class="nav-text">Configurações</span>
        </a>
      </li>
    </ul>
    <ul class="nav-logout" (click)="logout()">
      <li class="nav-item">
        <a class="nav-link logout">
          <div class="nav-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
              <polyline points="16 17 21 12 16 7"></polyline>
              <line x1="21" y1="12" x2="9" y2="12"></line>
            </svg>
          </div>
          <span class="nav-text">Sair</span>
        </a>
      </li>
    </ul>

  <div class="user-section">
    <div class="user-avatar">
      <img *ngIf="usuario" src="data:image/png;base64,{{usuario.imagem}}" width="36" height="36" style="border-radius: 50%" alt="" srcset="">
    </div>
    <div class="user-info">
      <div class="user-name">{{usuario.nome}}</div>
      <div class="user-role">{{roleView}}</div>
    </div>
  </div>
</aside>
<main class="main-content">
  <router-outlet></router-outlet>
</main>
</body>
<!--<router-outlet *ngIf="!(showMenu | async)"></router-outlet>-->
<app-loader-view></app-loader-view>
